//@flow

import {
  createPostApi,
  deletePostApi,
  editPostApi,
  getPostApi,
  endpoints,
  listPostsApi,
} from '../api/blog-post';
import {buildRoute} from '../../../http';

import type {
  EditBlogPost,
  CreateBlogPost,
  BlogPostFilter,
} from '../api/blog-post';
import type {
  BlogPost,
  PaginationRequest,
  PaginationResponse,
  BlogPostDetail,
} from '../../../entities';

export function createBlogPostService(post: CreateBlogPost): Promise<BlogPost> {
  return createPostApi(post).toPromise();
}

const defaultPagination: PaginationRequest = {
  page: 0,
  size: 10,
};

export function listBlogPostsService(
  filter?: BlogPostFilter = {},
  pagination?: PaginationRequest = defaultPagination
): Promise<PaginationResponse<BlogPost>> {
  const {page, size} = pagination;
  // $FlowFixMe
  const params = {
    page,
    size,
    ...filter,
  };

  if (typeof params.title === 'string' && params.title.length === 0) {
    params.title = undefined;
  }

  return listPostsApi(params).toPromise();
}

export function getBlogPostService(id: string): Promise<BlogPostDetail> {
  const route = buildRoute(endpoints.GET_POST, [id]);
  return getPostApi(undefined, {route}).toPromise();
}

export function editBlogPostService(
  id: string,
  post: EditBlogPost
): Promise<BlogPost> {
  const route = buildRoute(endpoints.EDIT_POST, [id]);
  return editPostApi(post, {route}).toPromise();
}

export function deleteBlogPostService(id: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_POST, [id]);
  return deletePostApi({route}).toPromise();
}
